// extracted by mini-css-extract-plugin
export var capabilities = "style-module--capabilities--b12e8";
export var capabilities__featured = "style-module--capabilities__featured--d35c9";
export var capabilities__image = "style-module--capabilities__image--3a0cb";
export var capabilities__imageWrap = "style-module--capabilities__image-wrap--49d2c";
export var capabilities__link = "style-module--capabilities__link--45f1e";
export var capabilities__newTag = "style-module--capabilities__newTag--f573f";
export var capabilities__text = "style-module--capabilities__text--734d6";